import { Module } from "wrapper6";
import LoadPosts from '../utils/_load-posts';

export default class LatestPostsFilter extends Module {
  ready() {
    this.WRAPPER = document.querySelector('.mtt-latest-posts');
    this.loading = false;

    if (this.WRAPPER) {
      this.FILTER_ITEMS = this.WRAPPER.querySelectorAll('.mtt-latest-posts__filter-item button');
      this.POST_GRID_WRAP = this.WRAPPER.querySelector('.mtt-latest-posts__grid-wrap');
      this.POST_GRID = this.WRAPPER.querySelector('.mtt-latest-posts__grid');

      this.postLoader = new LoadPosts({
        action: 'load_posts',
        postType: 'post',
        postsToLoad: 4,
        taxonomy: 'category'
      });

      this.addListeners();
    }
  }

  addListeners() {
    for (let i = 0; i < this.FILTER_ITEMS.length; i++) {
      const ITEM = this.FILTER_ITEMS[i];
      ITEM.addEventListener('click', event => this.filterPosts(event));
    }
  }

  getTermID(event) {
    return event.currentTarget.getAttribute('data-term-id');
  }

  setActiveItem(event) {
    document.querySelector('.mtt-latest-posts__filter-item--active').classList.remove('mtt-latest-posts__filter-item--active');
    event.currentTarget.parentNode.classList.add('mtt-latest-posts__filter-item--active');
  }

  startLoading() {
    this.loading = true;
    this.POST_GRID_WRAP.classList.add('mtt-latest-posts__grid-wrap--loading');
  }

  stopLoading() {
    this.loading = false;
    this.POST_GRID_WRAP.classList.remove('mtt-latest-posts__grid-wrap--loading');
  }

  filterPosts(event) {
    if (this.loading === true || event.currentTarget.parentNode.classList.contains('mtt-latest-posts__filter-item--active')) {
      return false;
    }

    const TERM_ID = this.getTermID(event);

    this.startLoading();
    this.setActiveItem(event);
    this.postLoader.setTermID(TERM_ID);

    this.postLoader.fetchPosts().then(result => {
      if (result) {
        this.POST_GRID.innerHTML = result.data;
      }

      this.stopLoading();
    })
  }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_latest-posts-filter.js